export default {
  'Verification.one': 'one',
  'Verification.two': 'two',
  'Verification.three': 'three',
  'Verification.shop': 'four',
  'Verification.five': 'five',
  'Verification.land': 'six',
  'Verification.Seven': 'seven',
  'Verification.splitOpen': 'eight',
  'Verification.Nine': 'nine',
  'Verification.ParentVerification': 'Parent Verification',
  'Verification.ClickInOrder': 'Click in order:'
};
